exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.context-menu[data-v-38fdfe13]{\n    position: fixed;\n    z-index: 9999999999;\n    overflow: hidden\n}\n\n\n", "", {"version":3,"sources":["/tentcoo/jenkins/workspace/epm-prod-deploy-web-pc/src/components/context-menu/index.vue"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;CACnB","file":"index.vue","sourcesContent":["\n.context-menu[data-v-38fdfe13]{\n    position: fixed;\n    z-index: 9999999999;\n    overflow: hidden\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38fdfe13","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/context-menu/index.vue
// module id = s0wn
// module chunks = 6